module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Color-profile-16749f18efeadcb336f573ccbed06f95.svg";